import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '../stores/auth';

const router = createRouter({
    history: createWebHistory(window.APP_IDENTITY?.ROUTER_BASE || '/'),
    routes: [
        {
            path: '/login',
            name: 'login',
            component: () => import('../views/LoginView.vue'),
            meta: { guest: true }
        },
        {
            path: '/',
            name: 'dashboard',
            component: () => import('../views/DashboardView.vue'),
            meta: { auth: true, admin: true }
        },
        {
            path: '/user-dashboard',
            name: 'user-dashboard',
            component: () => import('../views/DashboardUserView.vue'),
            meta: { auth: true }
        },
        // Admin Routes
        {
            path: '/admin/users',
            name: 'manage-users',
            component: () => import('../views/admin/ManageUserView.vue'),
            meta: { auth: true, admin: true }
        },
        {
            path: '/admin/employees',
            name: 'manage-employees',
            component: () => import('../views/admin/ManageEmployeeView.vue'),
            meta: { auth: true, admin: true }
        },
        {
            path: '/admin/services',
            name: 'manage-services',
            component: () => import('../views/admin/ProductServicesView.vue'),
            meta: { auth: true, admin: true }
        },
        {
            path: '/admin/cashflow',
            name: 'admin-cashflow',
            component: () => import('../views/admin/CashFlowView.vue'),
            meta: { auth: true, admin: true }
        },
        // Tailoring Routes
        {
            path: '/tailoring/customers',
            name: 'manage-customers',
            component: () => import('../views/tailoring/ManageCustomerView.vue'),
            meta: { auth: true }
        },
        {
            path: '/tailoring/job-orders',
            name: 'job-orders',
            component: () => import('../views/tailoring/JobOrdersView.vue'),
            meta: { auth: true }
        },
        {
            path: '/tailoring/closing',
            name: 'cashier-closing',
            component: () => import('../views/tailoring/CashierClosingView.vue'),
            meta: { auth: true }
        },
        {
            path: '/tailoring/sewer',
            name: 'sewer-tracking',
            component: () => import('../views/tailoring/ManageSewerView.vue'),
            meta: { auth: true }
        },
        {
            path: '/tailoring/sewer-reports',
            name: 'sewer-reports',
            component: () => import('../views/tailoring/SewerReportView.vue'),
            meta: { auth: true }
        },
        {
            path: '/tailoring/schedule',
            name: 'release-schedule',
            component: () => import('../views/tailoring/ScheduleView.vue'),
            meta: { auth: true }
        },
        {
            path: '/tailoring/repair',
            name: 'job-repair',
            component: () => import('../views/tailoring/JobRepairView.vue'),
            meta: { auth: true }
        },
        // Inventory Routes
        {
            path: '/inventory/items',
            name: 'inventory-items',
            component: () => import('../views/inventory/InventoryItemsView.vue'),
            meta: { auth: true }
        },
        {
            path: '/inventory/receive',
            name: 'inventory-receive',
            component: () => import('../views/inventory/ReceiveInventoryView.vue'),
            meta: { auth: true }
        },
        {
            path: '/inventory/request',
            name: 'inventory-request',
            component: () => import('../views/inventory/RequestInventoryView.vue'),
            meta: { auth: true }
        },
        {
            path: '/inventory/release',
            name: 'inventory-release',
            component: () => import('../views/inventory/ReleaseInventoryView.vue'),
            meta: { auth: true }
        },
        // Payroll Route
        {
            path: '/payroll',
            name: 'payroll-list',
            component: () => import('../views/payroll/PayrollView.vue'),
            meta: { auth: true }
        },
        {
            path: '/payroll/details/:id',
            name: 'payroll-details',
            component: () => import('../views/payroll/PayrollEmployeesView.vue'),
            meta: { auth: true }
        },
        {
            path: '/payroll/cash-advance',
            name: 'cash-advance',
            component: () => import('../views/payroll/CashAdvanceView.vue'),
            meta: { auth: true }
        },
        // Expenses Routes
        {
            path: '/expenses',
            name: 'manage-expenses',
            component: () => import('../views/expenses/ExpensesView.vue'),
            meta: { auth: true }
        },
        {
            path: '/:pathMatch(.*)*',
            redirect: '/'
        }
    ]
});

router.beforeEach((to, from, next) => {
    const auth = useAuthStore();

    if (to.meta.auth && !auth.isLoggedIn) {
        next('/login');
    } else if (to.meta.guest && auth.isLoggedIn) {
        next('/');
    } else if (to.meta.admin && !auth.isAdmin) {
        next('/');
    } else {
        next();
    }
});

export default router;
